import React from "react";
import styles from "./MobileCustomRowStyles.module.css";
import MoreHoriz from "@material-ui/icons/MoreHoriz";
import { QuestionHeading } from "../QuestionHeading/QuestionHeading";
import { QuestionMandatoryCheckbox } from "features/Account/modules/Communications/modules/ContactForm/modules/ContactFormQuestionsList/modules/QuestionMandatoryCheckbox/QuestionMandatoryCheckbox";
import { DragIndicator } from "../DragIndicator/DragIndicator";
import { useActionFieldModalWrapper } from "../ActionsField/modules/ActionFieldsModalWrapper/utils/useActionFieldModalWrapper";

export const MobileCustomRow = (props) => {
  const { item, handleToggleQuestionMandatory } = props;
  const { openActionFieldModal } = useActionFieldModalWrapper();
  return (
    <div className={styles.row}>
      <DragIndicator
        iconWrapperStyle={styles.dragIndicator}
        disabled={item.isDragDisabled}
      />
      <div className={styles.topSection}>
        <div className={styles.heading}>
          <QuestionHeading record={item} />
        </div>
        <MoreHoriz onClick={() => openActionFieldModal({ record: item })} />
      </div>
      <div className={styles.bottomSection}>
        <QuestionMandatoryCheckbox
          handleToggleQuestionMandatory={handleToggleQuestionMandatory}
          record={item}
        />
        <div className={styles.text}>Is Mandatory</div>
      </div>
    </div>
  );
};
